<template>
  <LayoutClassicTour>
    <SectionContainer
      class="mt-1"
      :title="`Most recent ${data.sponsor.name} videos included with ${currentSite.name}`"
    >
      <template #leading-header>
        <img
          :src="`/images/sites/${currentSite.slug}/sponsors/${data.sponsor.cachedSlug}.png`"
        />
      </template>

      <div class="card-grid">
        <ReleaseCard
          v-for="(release, i) in data.releases.items"
          :key="`sponsor-releases-${route.params.slug}-${i}`"
          :release="release"
          :vertical="useVerticalCards"
        />
      </div>
    </SectionContainer>

    <Pagination
      :resource="`sites/${route.params.slug}`"
      :current-page="page"
      :total-pages="data.releases.pagination.totalPages"
    />
  </LayoutClassicTour>
</template>

<script setup>
  useRedirectInAgeRestrictedArea()

  const route = useRoute()
  const currentSite = inject("currentSite")
  const inAgeRestrictedLocation = inject("inAgeRestrictedLocation")
  const { notFoundUrl, useVerticalCards, hasSubSites } = useSiteSettings(
    currentSite.value,
  )
  const page = parseInt(route.query.page) || 1
  const perPage = 24

  const { data } = await useApi(`/api/sponsors/${route.params.slug}`, {
    query: {
      page,
      per_page: perPage,
      age_restricted: inAgeRestrictedLocation,
    },
  })

  if (!data.value) {
    navigateTo(notFoundUrl, { external: true, statusCode: 302 })
  } else {
    useSiteSeo(
      {
        defaultDescription:
          "Check out all of the {{{ sponsorName }}} movies in HD {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
        defaultTitle:
          "{{{ sposorName }}} Videos - {{ siteName }} {{#showPageNumber}} | Page: {{ pageNumber }}{{/showPageNumber}}",
        pageNumber: page,
        sponsorName: data.value.sponsor.name,
      },
      {},
      { canonicalPath: seriesHubPath(route.params.slug, { hasSubSites }) },
    )
  }
</script>
